<template>
    <v-card>
        <v-card-title class="text-h5">
            <v-btn
                class="mr-3"
                depressed
                color="primary"
                icon
                rounded
                @click="close"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            {{ workOrder.code }}
            Assembly Components</v-card-title
        >
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-data-table
                id="virtual-scroll-table"
                disable-pagination
                hide-default-footer
                :headers="headers"
                :items="filteredComponents"
                class="elevation-0"
                :mobile-breakpoint="0"
                fixed-header
                :style="{ width: '100%' }"
                :height="$vuetify.breakpoint.mdAndDown ? '70vh' : '65vh'"
                :loading="loading"
                show-expand
                item-key="partNumber"
            >
                <template v-slot:top>
                    <v-row
                        no-gutter
                        class="mt-0 mx-0 pt-4 pb-0 pb-4 align-center"
                        :style="{ 'background-color': '#eeeeee' }"
                    >
                        <v-col cols="9">
                            <h2 class="ml-4">COMPONENTS</h2>
                            <v-spacer />
                        </v-col>
                    </v-row>
                </template>
                <!--HEADERS-->
                <template v-slot:[`header.partNumber`]="{ header }">
                    <v-text-field
                        class="py-2 mt-2 custom-label"
                        :label="header.text"
                        v-model="partNumberToFilter"
                        dense
                    />
                </template>
                <!--ITEMS-->
                <template v-slot:expanded-item="{ item }">
                    <td :colspan="headers.length" class="py-4">
                        <v-data-table
                            :headers="workOrderHeaders"
                            :items="item.workOrders || []"
                            class="elevation-0"
                            disable-pagination
                            hide-default-footer
                            dense
                        >
                            <template
                                v-slot:[`item.workOrder`]="{
                                    item: workOrderItem,
                                }"
                            >
                                <div class="d-flex justify-center">
                                    <p class="my-0">
                                        {{ workOrderItem.workOrder }}
                                    </p>
                                </div>
                            </template>
                            <template
                                v-slot:[`item.woQty`]="{ item: workOrderItem }"
                            >
                                <div class="d-flex justify-center">
                                    <p class="my-0">
                                        {{ getWoQty(workOrderItem) }}
                                    </p>
                                </div>
                            </template>
                            <template
                                v-slot:[`item.producedQty`]="{
                                    item: workOrderItem,
                                }"
                            >
                                <div class="d-flex justify-center">
                                    <p class="my-0">
                                        {{ getProducedQty(workOrderItem) }}
                                    </p>
                                </div>
                            </template>
                            <template
                                v-slot:[`item.qtyInStock`]="{
                                    item: workOrderItem,
                                }"
                            >
                                <div class="d-flex justify-center">
                                    <p class="my-0">
                                        {{
                                            getUsedFromStock({
                                                partNumberId:
                                                    workOrderItem.partNumberId,
                                                workOrderCode:
                                                    workOrderItem.workOrder,
                                            })
                                        }}
                                    </p>
                                </div>
                            </template>
                            <template
                                v-slot:[`item.lastProcess`]="{
                                    item: workOrderItem,
                                }"
                            >
                                <div class="d-flex justify-center">
                                    <p class="my-0">
                                        {{ getLastProcessName(workOrderItem) }}
                                    </p>
                                </div>
                            </template>
                        </v-data-table>
                    </td>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'
import moment from 'moment'

export default {
    name: 'AssemblyInformation',
    components: {},
    props: {
        workOrder: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        packingProcess: {
            id: 'packing',
            name: 'Packing',
        },
        readyForPackingProcess: {
            id: 'readyForPacking',
            name: 'readyForPacking',
        },
        qualityProcess: {
            id: 'quality',
            name: 'Quality',
        },
        headers: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
                width: '200px',
            },
            {
                text: 'TOTAL QTY',
                value: 'totalQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'RECEIVED QTY',
                value: 'receivedQty',
                align: 'center',
                sortable: false,
            },
        ],
        workOrderHeaders: [
            {
                text: 'WORK ORDER',
                value: 'workOrder',
                align: 'center',
                sortable: false,
            },
            {
                text: 'WO QTY',
                value: 'woQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PRODUCED QTY',
                value: 'producedQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'LAST PROCESS',
                value: 'lastProcess',
                align: 'center',
                sortable: false,
            },
        ],
        components: [],
        partNumberToFilter: null,
        processes: {},
        project: {},
        partNumbers: {},
        settingProcesses: undefined,
        stock: [],
    }),
    computed: {
        filteredComponents() {
            let conditions = []

            if (this.partNumberToFilter) {
                conditions.push(this.filterForPartNumber)
            }

            if (conditions.length > 0) {
                return this.components.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }

            return this.components
        },
    },

    async mounted() {
        try {
            this.loading = true
            const {
                data: { settings },
            } = await API.getSettings()
            this.settingProcesses = settings.find(
                setting => setting.name.toLowerCase() == 'processes'
            )
            if (this.settingProcesses) {
                // Add quality and packing processes to settingProcesses
                this.settingProcesses.processes.push(
                    ...[this.qualityProcess, this.packingProcess]
                )
                const processes = this.settingProcesses.processes
                for (const process of processes) {
                    this.processes[process.id] = process
                }
            }
            const {
                data: { users },
            } = await API.getLiteUsers()
            this.users = users
            this.projectWorkOrders = await API.getWorkOrdersByProject({
                projectId: this.workOrder.projectId,
                includeClosed: false,
            })
            let componentsObject = this.formatComponents()
            this.formatWorkOrders(componentsObject)
            this.project = await API.getProject(this.workOrder.projectId)
            this.partNumbers = await API.getPartNumbersInKeys({
                projectId: this.workOrder.projectId,
            })
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('closeDialog')
        },
        filterForPartNumber(item) {
            return (
                item.partNumber &&
                item.partNumber
                    .toLowerCase()
                    .includes(this.partNumberToFilter.toLowerCase())
            )
        },
        getUserName(userId) {
            const user = this.users.find(u => u.id == userId)
            let name = ''
            if (user) {
                name = user.name
            }
            return name
        },
        formatDate(seconds) {
            return `${moment.unix(seconds).format('YYYY-MM-DD HH:mm')}`
        },
        formatComponents() {
            let componentsObject = {}
            if (this.workOrder.partNumbers) {
                for (const partNumber of Object.values(
                    this.workOrder.partNumbers
                )) {
                    Object.values(partNumber.assemblyItems).forEach(
                        component => {
                            // get production info
                            partNumber.productionInfo = this.calculateFinished(
                                partNumber
                            )
                            // Calculate receivedQty based on produced quantity
                            const receivedQty = this.getReceivedQty(
                                component,
                                partNumber
                            )

                            if (componentsObject[component.partNumber]) {
                                componentsObject[
                                    component.partNumber
                                ].totalQty +=
                                    component.qtyPerAssembly *
                                    partNumber.quantity
                                componentsObject[
                                    component.partNumber
                                ].receivedQty += receivedQty
                            } else {
                                componentsObject[
                                    component.partNumber
                                ] = component
                                componentsObject[
                                    component.partNumber
                                ].totalQty =
                                    component.qtyPerAssembly *
                                    partNumber.quantity
                                componentsObject[
                                    component.partNumber
                                ].workOrders = []
                                componentsObject[
                                    component.partNumber
                                ].receivedQty = receivedQty
                            }
                        }
                    )
                }
            }
            return componentsObject
        },
        getReceivedQty(item, assembly) {
            if (!item || !assembly) {
                return 0
            }

            // Get the produced quantity from the parent assembly
            let producedQty = 0

            if (assembly.productionInfo && assembly.productionInfo.length > 0) {
                // Find the first production process (excluding quality and packing)
                const firstProductionProcess = assembly.productionInfo.find(
                    p =>
                        p.id !== this.qualityProcess.id &&
                        p.id !== this.packingProcess.id &&
                        p.id !== this.readyForPackingProcess.id
                )

                if (firstProductionProcess) {
                    producedQty = firstProductionProcess.produced || 0
                } else if (assembly.productionInfo.length > 0) {
                    // Fallback to first process if no production process found
                    producedQty = assembly.productionInfo[0].produced || 0
                }
            }

            // Calculate: qtyPerAssembly * produced quantity of assembly
            const qtyPerAssembly = Number(item.qtyPerAssembly || 0)
            const receivedQty = qtyPerAssembly * producedQty

            return Math.trunc(receivedQty)
        },
        formatWorkOrders(componentsObject) {
            this.projectWorkOrders.forEach(workOrder => {
                if (workOrder.partNumbers) {
                    Object.values(workOrder.partNumbers).forEach(
                        partNumberData => {
                            partNumberData.workOrder = workOrder.code
                            if (partNumberData.partNumber) {
                                if (
                                    componentsObject[
                                        partNumberData.partNumber
                                    ] &&
                                    partNumberData.processes &&
                                    partNumberData.processes.length > 1 &&
                                    this.processes[
                                        partNumberData.processes[
                                            partNumberData.processes.length - 1
                                        ]
                                    ] &&
                                    this.processes[
                                        partNumberData.processes[
                                            partNumberData.processes.length - 1
                                        ]
                                    ].assemblyProcess
                                ) {
                                    componentsObject[
                                        partNumberData.partNumber
                                    ].workOrders.push(partNumberData)
                                }
                            }
                        }
                    )
                }
            })

            this.components = Object.values(componentsObject)
            this.components.sort((a, b) =>
                a.partNumber.localeCompare(b.partNumber)
            )
        },
        getWoQty(workOrderItem) {
            return workOrderItem.quantity || 0
        },
        getLastProcessName(workOrderItem) {
            const lastProcessId =
                workOrderItem.processes[workOrderItem.processes.length - 2]
            const process = this.processes[lastProcessId]

            return process ? process.name : '-'
        },
        getProducedQty(workOrderItem) {
            const lastProcessId =
                workOrderItem.processes[workOrderItem.processes.length - 2]

            let producedQty = 0
            if (workOrderItem.production) {
                const lastProcessProduction = workOrderItem.production.filter(
                    p => p.process && p.process.id === lastProcessId
                )
                producedQty = lastProcessProduction.reduce(
                    (sum, p) => sum + (p.qty || 0),
                    0
                )
            }
            return producedQty
        },
        getUsedFromStock({ partNumberId, workOrderCode }) {
            if (
                !this.partNumbers ||
                Object.keys(this.partNumbers).length === 0
            ) {
                return 0
            }
            if (
                !this.partNumbers[partNumberId] ||
                !this.partNumbers[partNumberId].deliveries ||
                this.partNumbers[partNumberId].deliveries.length === 0
            ) {
                return 0
            }
            //unify deliveries
            let unifiedDeliveries = []
            for (const delivery of this.partNumbers[partNumberId].deliveries) {
                if (delivery.originWorkOrder === workOrderCode) {
                    unifiedDeliveries.push({
                        code: this.partNumbers[partNumberId].code,
                        ...delivery,
                    })
                }
            }

            const stockQuantity = unifiedDeliveries.reduce(
                (acc, delivery) => acc + delivery.qty,
                0
            )
            return stockQuantity
        },
        formatStock() {
            const partNumberStock = this.partNumbers
            let version2Deliveries = []

            if (partNumberStock && Object.entries(partNumberStock).length > 0) {
                for (let [partNumberId, partNumber] of Object.entries(
                    partNumberStock
                )) {
                    //version 2 support
                    if (partNumber.deliveries) {
                        //unify deliveries
                        let unifiedDeliveries = []
                        for (const delivery of partNumber.deliveries) {
                            unifiedDeliveries.push({
                                code: partNumber.code,
                                ...delivery,
                            })
                        }
                        //get origin work orders
                        const baseWorkOrders = new Set(
                            unifiedDeliveries.map(
                                delivery => delivery.originWorkOrder
                            )
                        )
                        Array.from(baseWorkOrders).forEach(workOrder => {
                            //filtered deliveries
                            const filteredDeliveries = unifiedDeliveries.filter(
                                delivery =>
                                    delivery.originWorkOrder === workOrder
                            )
                            const stockQuantity = filteredDeliveries.reduce(
                                (acc, delivery) => acc + delivery.qty,
                                0
                            )

                            if (stockQuantity > 0) {
                                version2Deliveries.push({
                                    projectId: this.project.id,
                                    projectReference: this.project.reference,
                                    projectSapCode: this.project.sapCode,
                                    projectName: this.project.name,
                                    partNumberId: partNumberId,
                                    partNumberCode: partNumber.code,
                                    stockQuantity: stockQuantity,
                                    originWorkOrders: [workOrder],
                                    version: 2,
                                })
                            }
                        })
                    }
                }
            }
            this.stock = [...this.stock, ...version2Deliveries]
        },
        calculateQualityPending(item) {
            try {
                let pendingQty = 0
                if (
                    item.processes.includes(this.qualityProcess.id) ||
                    this.workOrder.assemblyWorkOrder == undefined
                ) {
                    let lastProcessIndex = item.processes.length - 1
                    if (this.workOrder.assemblyWorkOrder != undefined) {
                        lastProcessIndex =
                            item.processes.findIndex(
                                p => p == this.qualityProcess.id
                            ) - 1
                    }
                    if (lastProcessIndex > -1) {
                        const lastProductionProcess =
                            item.processes[lastProcessIndex]
                        if (item.production) {
                            const production = item.production.filter(
                                entry =>
                                    entry.process.id == lastProductionProcess
                            )
                            if (production.length > 0) {
                                pendingQty = production.reduce(
                                    (accumulator, entry) =>
                                        accumulator + entry.qty,
                                    0
                                )
                            }
                        }
                        if (item.quality) {
                            const rejected = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.rejectQty || 0),
                                0
                            )
                            const released = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.releaseQty || 0),
                                0
                            )
                            pendingQty -=
                                Number(released || 0) + Number(rejected || 0)
                        }
                    }
                } else {
                    pendingQty = -1
                }

                return pendingQty
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateReleasedQty(item) {
            try {
                let released = 0
                if (
                    item.processes.includes(this.qualityProcess.id) ||
                    this.workOrder.assemblyWorkOrder == undefined
                ) {
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.releaseQty || 0),
                            0
                        )
                        released += Number(value || 0)
                    }
                } else {
                    released = -1
                }

                return released
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateRejectedQty(item) {
            try {
                let rejected = 0
                if (
                    item.processes.includes(this.qualityProcess.id) ||
                    this.workOrder.assemblyWorkOrder == undefined
                ) {
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.rejectQty || 0),
                            0
                        )
                        rejected += Number(value || 0)
                    }
                } else {
                    rejected = -1
                }
                return rejected
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateFinished(item) {
            let productionInfo = []

            let qualityProcess = {
                id: this.qualityProcess.id,
                name: this.qualityProcess.name,
                qty: 0,
                received: 0,
                delivered: 0,
                produced: 0,
                available: 0,
            }

            let packingProcess = {
                id: this.packingProcess.id,
                name: this.packingProcess.name,
                qty: 0,
                received: 0,
                delivered: 0,
                produced: 0,
                available: 0,
            }
            if (item && item.processes && this.settingProcesses) {
                if (item.processes) {
                    item.processes.forEach(process => {
                        const pIndex = item.processes.findIndex(
                            p => p == process
                        )

                        let totalProduced = 0
                        let totalDelivered = 0
                        let totalReceived = 0
                        if (item.production) {
                            let production = item.production.filter(
                                register => register.process.id == process
                            )
                            totalProduced = production.reduce(
                                (total, register) => total + register.qty,
                                0
                            )
                        }
                        if (item.deliveries) {
                            let deliveries = item.deliveries.filter(
                                register => register.prevProcess.id === process
                            )
                            totalDelivered = deliveries.reduce(
                                (total, register) => total + register.qty,
                                0
                            )

                            if (pIndex > 0) {
                                let received = item.deliveries.filter(
                                    register =>
                                        register.nextProcess.id == process &&
                                        register.receivedBy
                                )
                                totalReceived = received.reduce(
                                    (total, register) => total + register.qty,
                                    0
                                )
                            } else {
                                totalReceived = item.quantity
                            }
                        }
                        if (pIndex == 0 && !this.workOrder.assemblyWorkOrder) {
                            totalReceived = item.quantity
                        }

                        if (pIndex == 0 && this.workOrder.assemblyWorkOrder) {
                            totalReceived = item.quantity
                            //TODO: Implement assembly items delivery calculation
                            // if (item.assemblyItems) {
                            //     Object.values(item.assemblyItems).forEach(
                            //         ai => {
                            //             let receivedQty = 0
                            //             if (ai.deliveries) {
                            //                 receivedQty = ai.deliveries.reduce(
                            //                     (accumulator, delivery) =>
                            //                         accumulator + delivery.qty,
                            //                     0
                            //                 )
                            //             }
                            //             const assemblyQty =
                            //                 receivedQty / ai.qtyPerAssembly
                            //             if (assemblyQty < totalReceived) {
                            //                 totalReceived = assemblyQty
                            //             }
                            //         }
                            //     )
                            // }
                        }

                        item.dataProcesses = this.settingProcesses.processes.filter(
                            process => item.processes.includes(process.id)
                        )
                        let processIndex = item.dataProcesses.findIndex(
                            p => p.id == process
                        )
                        if (process == this.qualityProcess.id) {
                            //quality process
                            qualityProcess.qty += item.quantity
                            qualityProcess.delivered = 'NA'
                            qualityProcess.produced =
                                this.calculateRejectedQty(item) +
                                this.calculateReleasedQty(item)
                            qualityProcess.available = this.calculateQualityPending(
                                item
                            )
                            qualityProcess.assemblyProcess = false

                            productionInfo.push(qualityProcess)
                        } else if (process == this.packingProcess.id) {
                            //ready for packing process
                            let received = []
                            if (item.deliveries) {
                                received = item.deliveries.filter(
                                    register =>
                                        register.nextProcess.id == process &&
                                        register.receivedBy
                                )
                            }

                            totalReceived = received.reduce(
                                (total, register) => total + register.qty,
                                0
                            )

                            packingProcess.qty += item.quantity
                            packingProcess.delivered = 'NA'
                            packingProcess.produced += item.packedQty
                            packingProcess.available =
                                totalReceived - (packingProcess.produced || 0)
                            packingProcess.assemblyProcess = false

                            productionInfo.push(packingProcess)
                        } else if (
                            item.qtyInAssembly &&
                            pIndex == item.processes.length - 1
                        ) {
                            productionInfo.push({
                                name: item.dataProcesses[processIndex].name,
                                id: process,
                                produced:
                                    totalReceived > item.qtyInAssembly
                                        ? item.qtyInAssembly
                                        : totalReceived,
                                delivered: totalDelivered,
                                received: totalReceived,
                                available:
                                    totalReceived - item.qtyInAssembly > 0
                                        ? totalReceived - item.qtyInAssembly
                                        : 0,
                                assemblyProcess: item.dataProcesses[
                                    processIndex
                                ].assemblyProcess
                                    ? item.dataProcesses[processIndex]
                                          .assemblyProcess
                                    : false,
                            })
                        } else {
                            productionInfo.push({
                                name: item.dataProcesses[processIndex].name,
                                id: process,
                                produced: totalProduced,
                                delivered: totalDelivered,
                                received: totalReceived,
                                available: totalReceived - totalProduced,
                                assemblyProcess: item.dataProcesses[
                                    processIndex
                                ].assemblyProcess
                                    ? item.dataProcesses[processIndex]
                                          .assemblyProcess
                                    : false,
                            })
                        }
                    })
                }
                if (this.workOrder.assemblyWorkOrder == undefined) {
                    //quality process
                    qualityProcess.qty += item.quantity
                    qualityProcess.delivered = 'NA'
                    qualityProcess.produced =
                        this.calculateRejectedQty(item) +
                        this.calculateReleasedQty(item)
                    qualityProcess.available = this.calculateQualityPending(
                        item
                    )

                    productionInfo.push(qualityProcess)

                    let totalReceivedNew = item.deliveries
                        ? item.deliveries.reduce(
                              (total, register) =>
                                  register.nextProcess.id ==
                                      this.packingProcess.id &&
                                  register.receivedBy
                                      ? total + register.qty
                                      : total,
                              0
                          )
                        : 0

                    let totalReceivedOld = item.deliveries
                        ? item.deliveries.reduce(
                              (total, register) =>
                                  register.nextProcess.id ==
                                      this.readyForPackingProcess.id &&
                                  register.receivedBy
                                      ? total + register.qty
                                      : total,
                              0
                          )
                        : 0

                    packingProcess.qty += item.quantity
                    packingProcess.delivered = 'NA'
                    packingProcess.produced += item.packedQty
                    packingProcess.available =
                        totalReceivedOld +
                        totalReceivedNew -
                        (packingProcess.produced || 0)

                    productionInfo.push(packingProcess)
                }
            }

            return productionInfo || []
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
.v-data-table {
    border: 1px solid #eeeeee;
}
.v-data-table .v-data-table {
    width: 100%;
}
</style>
